import { StoreOperations, StoreSubjects } from '../../constants/constants';

export const canViewRequisition = (ability) =>
  ability?.can(StoreOperations.View, StoreSubjects.Requisition);
export const canCreateRequisition = (ability) =>
  ability?.can(StoreOperations.Create, StoreSubjects.Requisition);
export const canOrderOnBehalfRequisition = (ability) =>
  ability?.can(StoreOperations.onBehalfOrder, StoreSubjects.Requisition);
